import React, { useState, useEffect } from 'react';
import PropTypes  from 'prop-types';
import get from 'lodash/get'
import { Row, Col, Button } from 'reactstrap'
import { TextField, InputAdornment, IconButton, Switch } from '@material-ui/core/'
import { Field, reduxForm } from 'redux-form';
import moment from "moment"
import 'moment/locale/es'

// Redux
import { connect } from 'react-redux';
import { promptUser, showNormalNotification } from '../../../../redux/actions/notificationsActions';
import { updateDownloadIntegration, deleteDownloadIntegration } from '../../../../redux/actions/integrationsActions';

// Components
import LoadingButton from '../../../../components/LoadingButton';
import FormSatState from './FormSatState'

// Libs
import { segmentTrackEvent, getDate } from '../../../../libs/utils';

// Img
import { SAT_IMG } from '../../../../constants/assets';

// Icons
import EyeIcon from 'mdi-react/EyeIcon';
import EyeOffIcon from 'mdi-react/EyeOffIcon';
import HelpCircleIcon from 'mdi-react/HelpCircleIcon';

// ENV
import { REACT_APP_NEW_INTEGRATIONS_PUE_PAID } from '../../../../constants/app'

const renderTextField = ({ input = {}, label, meta: { touched, error }, type, InputProps }) => (
  <div className='material-form__field-wrapper'>
    <TextField
			id={input.name}
      className='material-form__field'
      variant="outlined"
      label={label}
      error={touched && !!error}
      type={type}
      value={input.value}
      onChange={(e) => {
        e.preventDefault();
        input.onChange(e.target.value);
      }}
      InputProps={ InputProps }
    />
    { touched && error && <span className='form__form-group-error'>{ error }</span> }
  </div>
); // END renderTextField


const FormSatDetail = (props) => {
  const { alert, updateDownloadIntegration, deleteDownloadIntegration, showPassword, setShowPassword, handleModal } = props;

  const [isLoading, setLoading] = useState(false)
  const [enabledDownload, setDownload] = useState(null)
  const [paidPue, setPaidPue] = useState(null)

  useEffect(() => {
    setDownload(get(props, 'sat_downloads.cfdi_download_enabled'))
    setPaidPue(get(props, 'sat_downloads.sync_paid_pue'))

    props.initialize({
      'sat_rfc': get(props, 'sat_downloads.sat_rfc'),
      'sat_ciec': '',
      'sync_start_date': get(props, 'sat_downloads.sync_start_date')
    })
  }, [enabledDownload])

  const onSubmit = (form) => {
    setLoading(true)
    const body = {
      sat_rfc: form.sat_rfc,
      sat_ciec: form.sat_ciec,
      sync_start_date: form.sync_start_date,
      sync_paid_pue: paidPue,
      cfdi_download_enabled: enabledDownload
    }

    updateDownloadIntegration(body)
      .then(() => {
        segmentTrackEvent('Update SAT Download Invoices', get(props, 'account.team.uuid'))
        setLoading(false)
      })
      .then(() => handleModal())
      .catch(error => {
        const errorObject = Object.assign({}, error)
        const segmentErrorBody = {
          error_status_code: get(errorObject, 'response.status'),
          error_code       : get(errorObject, 'response.data.code'),
          error_message    : get(errorObject, 'response.data.message')

        }
        segmentTrackEvent('Error On SAT Integration', get(props, 'account.team.uuid'), segmentErrorBody)
        setLoading(false)
        props.dispatch({ type: "ERROR", payload: error })
      })
  }

  const disable = e => {
    const { promptUser, dispatch } = props
    e.preventDefault();
    promptUser({
      title: '¿Eliminar integración?',
      message: 'Esta acción eliminará la integración actual con el SAT.',
      color: 'danger'
    })
      .then(confirmation => {
        if (confirmation === 'ok') {
            deleteDownloadIntegration()
              .then(() => {
                segmentTrackEvent('Disabled SAT Download Integration', get(props, 'account.team.uuid'))
                handleModal();

              })
        } else {
					handleModal();
          dispatch(showNormalNotification({ color: 'warning', message: 'Acción cancelada' }));

        }

      })
			.catch(error => dispatch({ type: "ERROR", payload: error }));
  }

  const disabledDownload = e => {
    const { promptUser, dispatch, form } = props
    const body = {
      sat_rfc: form.sat_rfc,
      sat_ciec: form.sat_ciec,
      sync_start_date: form.sync_start_date,
      sync_paid_pue: paidPue,
      cfdi_download_enabled: enabledDownload === 1 ? 0 : 1
    }

    e.preventDefault();
    if(enabledDownload === 0) {
      updateDownloadIntegration(body)
        .then(() => handleModal())
        .catch(error => props.dispatch({ type: "ERROR", payload: error }) )
    } else {
      promptUser({
      title: '¿Eliminar integración?',
      message: 'Esta acción desactivara la integración actual con el SAT.',
      color: 'danger'
    })
      .then(confirmation => {
        if (confirmation === 'ok') {
          updateDownloadIntegration(body)
            .then(() => handleModal())
            .catch(error => props.dispatch({ type: "ERROR", payload: error }) )
        } else {
					handleModal();
          dispatch(showNormalNotification({ color: 'warning', message: 'Acción cancelada' }));

        }

      })
      .catch(error => dispatch({ type: "ERROR", payload: error }));
    }

  }

  return (
    <div className="sat__integration">
      <FormSatState
        enabled={ get(props, 'enabled') }
        connection={ get(props, 'connection') }
        disabledIntegration={ disabledDownload }
        integrationEnabled={ enabledDownload }
      />
      <hr/>
      <Row className="row__info">
        <Col xs={2}>
          <img src={ SAT_IMG } alt="SAT_logo"/>
        </Col>
        <Col>
          <p>Ingresa tus credenciales CIEC para comenzar la descarga de facturas desde los servicios del SAT, de manera automática.</p>
        </Col>
      </Row>
      <Row className="margin-bottom">
        <Col xs={ 6 }>
          <p className="rfc__title">RFC</p>
          <p className="rfc__value">{ get(props, 'sat_downloads.sat_rfc') }</p>
        </Col>
        <Col>
          <p className="rfc__title">Razón Social</p>
          <p className="rfc__value">{ get(props, 'account.profile.legal_name') }</p>
          {/* <p className="rfc__value">{ get(props, 'integrations.sat.sat_legal_name') }</p> */}
        </Col>
      </Row>
      <Row className="margin-bottom">
        <Col xs={ 6 }>
          <p className="rfc__title">Última actualización con el SAT</p>
          <p className="rfc__value">{ moment.unix(get(props, 'sat_downloads.sync_date')).fromNow() }</p>
        </Col>
        <Col xs={ 6 }>
          <p className="rfc__title">Inicio de Sincronizacion</p>
          <p className="rfc__value">{ getDate(get(props, 'sat_downloads.sync_start_date'))}</p>
        </Col>
      </Row>
      <Row>
        <Col xs={ 6 }>
          <p className="rfc__ciec-text">Conexión con tu clave CIEC</p>
        </Col>
        <Col>
          <span className="help-text">
            <HelpCircleIcon/>
            <a target="_blank" rel="noopener noreferrer" href="https://www.sat.gob.mx/tramites/38517/generacion-y-actualizacion-de-contrasena-para-persona-fisica">
              ¿Cómo obtener tu clave CIEC?
            </a>
          </span>
        </Col>
      </Row>
      <hr className="margin-bottom" />
      <form className='material-form stripe' onSubmit={ props.handleSubmit(onSubmit) }>
        <Row className="margin-bottom">
          <Col>
            <Field
              name="sat_ciec"
              component={ renderTextField }
              label="Clave CIEC"
              type={ showPassword ? 'text' : 'password' }
              InputProps={{
                endAdornment: (
                  <InputAdornment
                    position="end"
                    disablePointerEvents={false}
                  >
                      <IconButton style={{padding:0}} onClick={ () => setShowPassword(!showPassword) }>
                        {showPassword ? <EyeOffIcon/> : <EyeIcon/>}
                      </IconButton>
                  </InputAdornment>
                )
              }}
            />
          </Col>
        </Row>
        { REACT_APP_NEW_INTEGRATIONS_PUE_PAID === 'true' &&
          <React.Fragment>
            <Row>
              <Col className="sat__pue-paid-switch">
                  <div>Sincronizar facturas <span>PUE</span> como pagadas</div><Switch checked={ paidPue === 1 ? true : false} color="primary" onClick={ () => setPaidPue(paidPue === 0 ? 1 : 0) } />
              </Col>
            </Row>
            <Row>
              <Col className="sat__pue-paid-note">
                { !!alert && alert(paidPue) }
              </Col>
            </Row>
          </React.Fragment>
        }
        <Row>
          <Col>
            {props.connection === 'failure' &&
              <div className="alert-error">
                <span>Error de autenticación con SAT:</span> Revisa tu clave CIEC y vuelve a ingresarla para continuar descargando CFDIs desde el SAT.
              </div>
            }
          </Col>
        </Row>
        <Row style={{marginTop:25}}>
          <Col xs={5}>
            <Button
              color="danger"
              onClick={ disable }>
              DESCONECTAR
            </Button>
          </Col>
          <Col style={{paddingLeft:0, display:"flex", justifyContent:"flex-end"}}>
            <Button className="save-button" color='success' type='submit' disabled={ isLoading }>
              <LoadingButton isLoading={ isLoading } placeholder='GUARDAR'/>
            </Button>
          </Col>
        </Row>
      </form>
    </div>
  )
}

FormSatDetail.propTypes = {
  alert: PropTypes.any,
  updateDownloadIntegration: PropTypes.func.isRequired,
  deleteDownloadIntegration: PropTypes.func.isRequired,
  showPassword: PropTypes.any,
  setShowPassword: PropTypes.func.isRequired,
  handleModal: PropTypes.func.isRequired,
  initialize: PropTypes.func.isRequired,
  dispatch: PropTypes.func.isRequired,
  promptUser: PropTypes.func.isRequired,
  form: PropTypes.object.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  connection: PropTypes.any,
};

const validate = values => {
  const { sat_ciec } = values, errors = {};

  if (!sat_ciec) errors.sat_ciec = 'Proporciona tu contraseña CIEC'

  return errors;

}; // END validate

export default reduxForm({ form: 'SAT_CIEC_INTEGRATION', validate })(connect(state => ({
  errors             : get(state, 'errors'),
	form               : get(state, 'form.SAT_CIEC_INTEGRATION.values'),
	sat_downloads      : get(state, 'integrations.sat_downloads'),
	account            : get(state, 'account'),
	enableReinitialize : true

}) , { promptUser, updateDownloadIntegration, deleteDownloadIntegration })(FormSatDetail)); // END connect export



// WEBPACK FOOTER //
// ./src/containers/account/components/satIntegration/FormSatDownloadDetail.js